import React, { useState, useRef, useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import axios from "../../API/axios";
import { getOwnCompaniesList } from "../../Services/apiService";
import { debounce } from "lodash";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import UseDebounce from "./UseDebounce";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles, wljSelectPortalProps } from "../../selectStyles";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import ReactQuill from "react-quill";
import { useTranslation } from "react-i18next";
import useEscapeKeyDown from "../../hooks/useEscapeKeyDown";
import { Portal } from "../../components/Portal";
import useIndustryScopedMaster from "../../hooks/useIndustryScopedMaster";
import { mapCompanyOption } from "../../utils/industryScopedMaster";
import {
  creatableSkillSelectDefaults,
  onCreatableInputChange,
} from "../../utils/creatableSelectHelpers";
import SkillSuggestChips from "../../components/SkillSuggestChips";

const DraftJob = ({
  onClose,
  data,
  showUserAuthModal,
  fetchData,
  companyDetails,
  openModal,
  restrictedViewerToken,
  showModal,
  closeModal,
  setCompanyStats,
  AllJobList,
  jobList,
  setJobList
}) => {
  const { t } = useTranslation();
  useEscapeKeyDown(showModal, closeModal);
  const master = useIndustryScopedMaster({
    language: localStorage.getItem("Lang"),
    sessionId: localStorage.getItem("sessionId"),
  });

  const sessionId = localStorage.getItem("sessionId");
  const companyJobCount = localStorage.getItem("companyJobCount");
  const fileInputRef = useRef(null);
  const fileInputRefBg = useRef(null);
  const [display, setDisplay] = useState(false);
  const language = localStorage.getItem("Lang");
  //   state for Next Previous Button
  const [activeStep, setActiveStep] = useState(1);
  
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handlePrev = () => {
    setActiveStep(activeStep - 1);
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };
  //************************Designation Start  ************************//
  const [value, setValue] = useState(null);
  const [page, setPage] = useState(0);
  const [typed, setTyped] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  console.log("options", options);

  const logValue = debounce((typed) => {
    setTyped(typed);
  }, 250);

  const addOptions = () => {
    if (!(master.fitid > 0)) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    axios
      .get(
        `Master/GetDesignationDDL?DeviceType=Web&search=${typed}&Fitid=${master.fitid}&pageNumber=${page + 1
        }&pageSize=100&LangKey=${language}`
      )
      .then((response) => {
        console.log("options", response);
        const data = response.data.responseData.data.map((item) => ({
          value: item.dsgntnId,
          label: item.name,
        }));
        setPage((prevPage) => prevPage + 1);
        setIsLoading(false);
        setOptions((prevOptions) => [...prevOptions, ...data]);
        setTotalPages(response.data.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleOpen = () => {
    setPage(1);
  };

  const handleChange = (value) => {
    console.log("value===========>", value);

    setValue(value);
    setPage(0);
  };

  const handleInputChange = (typed) => {
    logValue(typed);
    if (!typed) setPage(0);
  };

  const handleMenuScrollToBottom = () => {
    if (page < totalPages) {
      addOptions();
    }
  };

  const renderOption = ({
    focusedOption,
    focusOption,
    key,
    labelKey,
    option,
    selectValue,
    style,
    valueArray,
  }) => {
    // Your rendering logic here
  };

  useEffect(() => {
    if (typed) {
      addOptions();
    }
  }, [typed]);

  //************************ Designation End  ************************//

  //********City List Start  ********//
  const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState(null);
  const [citySearch, setCitySearch] = useState(null);
  const getCity = () => {
    axios
      .get(`Master/GetCitiesDDL?search=${citySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (citySearch) {
      getCity();
    }
  }, [citySearch]);
  //********City List End  ********//
  //********Job Type List Start  ********//
  const [jobTypeData, setJobTypeData] = useState([]);
  const [jobTypeId, setJobTypeId] = useState(null);
  const getJobType = () => {
    axios
      .get(`Master/GetJobTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setJobTypeData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    // getJobType();
  }, []);
  //********Job Type List End  ********//

  //********Company List Start  ********//
  console.log("companyDetails", companyDetails?.compUid);

  const [companyData, setCompanyData] = useState([]);
  const [companyId, setCompanyId] = useState(null);
  const [companyList, setCompanyList] = useState([]); // Store company list for later use in job posting
  const [isCompanyLoading, setIsCompanyLoading] = useState(false);
  const getCompany = async () => {
    // Creating from a company page: offer that company, but do not pre-select it.
    if (companyDetails && companyDetails.compUid) {
      setCompanyData([
        mapCompanyOption({
          compUid: companyDetails.compUid,
          compName: companyDetails.compName || companyDetails.name || "",
          industryId: companyDetails.industryId,
          industryName: companyDetails.industryName,
        }),
      ]);
      setIsCompanyLoading(false);
      return;
    }

    setIsCompanyLoading(true);
    try {
      const res = await getOwnCompaniesList({ forceRefresh: true });
      console.log(res);
      const companies = Array.isArray(res) ? res : [];
      const data = companies.map(mapCompanyOption);
      setCompanyData(data);
      setCompanyList(companies);
      localStorage.setItem("OwncompanyList", JSON.stringify(companies));
    } catch (error) {
      console.log(error);
    } finally {
      setIsCompanyLoading(false);
    }
  };
  useEffect(() => {
    if (showModal) {
      setCompanyId(null);
      master.resetMaster();
      getCompany();
    }
  }, [showModal, companyDetails?.compUid]);

  useEffect(() => {
    const refreshCompanies = () => {
      if (showModal) {
        getCompany();
      }
    };
    window.addEventListener("ownCompaniesListUpdated", refreshCompanies);
    return () =>
      window.removeEventListener("ownCompaniesListUpdated", refreshCompanies);
  }, [showModal, companyDetails?.compUid]);
  //********Company List End  ********//

  //********Work Location Type List Start  ********//
  const [workLocationData, setWorkLocationData] = useState([]);
  const [workLocationId, setWorkLocationId] = useState(null);
  const getWorkLocationType = () => {
    axios
      .get(`Master/GetWorkLocationTypesDDL?LangKey=${language}`)
      .then((response) => {
        // console.log(response.data.responseData);
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setWorkLocationData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    // getWorkLocationType();
  }, []);
  //********Work Location Type List End  ********//

  //********Work Level Type List Start  ********//
  const [workTypeData, setWorkTypeData] = useState([]);
  const [workTypeId, setWorkTypeId] = useState(null);
  const getWorkType = () => {
    axios
      .get(`Master/GetWorkLevelTypesDDL?LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({ value: item.id, label: item.name }));
        setWorkTypeData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    // getWorkType();
  }, []);
  //********Work Level Type List End  ********//

  //********Salary Type List Start  ********//
  const [salaryData, setsalaryData] = useState([]);
  const [salaryId, setsalaryId] = useState(null);
  const getsalaryType = () => {
    axios
      .get(`Master/GetSalaryTypesDDL?LangKey=${language}`)
      .then((response) => {
        // console.log(response.data.responseData);
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.jbSlryTypId,
          label: item.name,
        }));
        setsalaryData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }; 
  //********Salary Type List End  ********//

  const [jobTitle, setjobTitle] = useState("");
  const [minimumSalary, setMinimumSalary] = useState(null);
  const [maximumSalary, setMaximumSalary] = useState(null);
  const [hashtags, setHashtags] = useState("");
  const [jobDescription, setjobDescription] = useState("");
  const [jobId, setJobId] = useState("");

  // const debouncedMinimumSalary = UseDebounce(minimumSalary, 1000); // Adjust delay as needed
  // useEffect(() => {
  //   if (debouncedMinimumSalary) {
  //     UpdateDraft();
  //   }
  // }, [debouncedMinimumSalary]);

  const debouncedMaximumSalary = UseDebounce(maximumSalary, 1000); // Adjust delay as needed
  useEffect(() => {
    if (debouncedMaximumSalary) {
      UpdateDraft();
    }
  }, [debouncedMaximumSalary]);

  // const debouncedhashtags = UseDebounce(hashtags, 2000); // Adjust delay as needed
  // useEffect(() => {
  //   if (debouncedhashtags) {
  //     UpdateDraft();
  //   }
  // }, [debouncedhashtags]);

  const debouncedJobDescription = UseDebounce(jobDescription, 1000); // Adjust delay as needed
  useEffect(() => {
    if (debouncedJobDescription) {
      UpdateDraft();
    }
  }, [debouncedJobDescription]);
  const SaveDraft = async () => {
    try {
      const body = {
        deviceType: "Web",
        sessionId: sessionId,
        compUid: companyId,
        locationId: null,
        cityID: cityId,
        jbTypId: jobTypeId,
        workLevelType: workTypeId,
        workLocationType: workLocationId,
        designationName: master.jobMasterPayload().designationName || value?.label || value?.value,
        industryId: master.jobMasterPayload().industryId,
        skillIds: master.jobMasterPayload().skillIds,
        skillNames: master.jobMasterPayload().skillNames,
        salaryTypeId: salaryId,
        minSalary: minimumSalary,
        maxSalary: maximumSalary,
        currency: null,
        title: jobTitle,
        description: jobDescription,
        hashTags: hashtags,
        sourceTypeId: null,
        receiveApplicantsType: 1,
        langKey: language === "en" ? "" : language,
      };
      // console.log('body', body);
      // console.log("description", body)

      const res = await axios.post("/Job/SaveJobAsDraft", body);
      // console.log("response: ", res.data.responseData.id);
      setJobId(res.data.responseData.id);
      setToastMessage(res.data.message);
      setShowToast(true);
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const [updateMessage, setUpdateMessage] = useState('')
  const UpdateDraft = async () => {
    try {
      const body = {
        deviceType: "Web",
        sessionId: sessionId,
        jobId: jobId,
        compUid: companyId,
        locationId: null,
        cityID: cityId,
        jbTypId: jobTypeId,
        workLevelType: workTypeId,
        workLocationType: workLocationId,
        // "designationId": value,
        designationName: master.jobMasterPayload().designationName || value?.label || value?.value,
        industryId: master.jobMasterPayload().industryId,
        skillIds: master.jobMasterPayload().skillIds,
        skillNames: master.jobMasterPayload().skillNames,
        salaryTypeId: salaryId,
        minSalary: minimumSalary,
        maxSalary: maximumSalary,
        currency: null,
        title: jobTitle,
        description: jobDescription,
        hashTags: hashtags,
        sourceTypeId: null,
        receiveApplicantsType: 1,
        langKey: language === "en" ? "" : language,
      };
      console.log("body", body);
      // const res = await axios.put("/Job/UpdateDraftJob", body);
      const res = await axios.post("/Job/UpdateDraftJob", body); 
      setUpdateMessage(res.data.message) 
    } catch (e) {
      if (e.response && e.response.status === 404) {
      console.log("e", "body");

        // setWarningToastMessage(e.response.data.message);
        // setShowWarningToast(true);
      } else {
      console.log("e", "body");

        // setErrorToastMessage(e.response.data.message);
        // setShowErrorToast(true);
      }
    }
  };

 

  const UpdateJob = async () => {
     const isFirstJob = !jobList || jobList.length === 0;
    if (!(master.skills || []).length) {
      setWarningToastMessage("Add at least one skill before publishing. The job will stay a draft.");
      setShowWarningToast(true);
      return;
    }
    try {
      const body = {
        deviceType: "Web",
        sessionId: sessionId,
        jobId: jobId,
        langKey: language === "en" ? "" : language,
      }; 
      const res = await axios.put("Job/CompleteJobPosting", body); 
    //  console.log("jsjsjjsjs", res);
     
      console.log("CompleteJobPosting", showToast);
      setShowToast(true);
      setToastMessage(res.data.message);
      setTimeout(() => {
        
        closeModal(); 
      }, 1000);
      
      setCompanyStats((prev) => ({
        ...prev,
        totalJobs:(prev.totalJobs || 0) + 1,
      }))
      
      const newCompanyJobCount = parseInt(companyJobCount) + 1;
      localStorage.setItem("companyJobCount", newCompanyJobCount);

      const newJobId = res?.data?.responseData?.id
      const updateResponse = await axios.get(`Job/GetJobDetails?DeviceType=Web&JobId=${newJobId}&LangKey=${language === "en" ? "" : language}`)
      // console.log("Add New Post==>",updateResponse)
         const newPost = updateResponse?.data?.responseData?.viewJob;
      // setJobList((prev) => [newPost, ...prev]);
      setJobList((prev = []) => [newPost, ...prev]);

     if (isFirstJob) {
      setTimeout(() => {
        window.location.reload();
      }, 500); // small delay so toast is visible
    } 

    } catch (e) {
      const rd = e?.response?.data?.responseData || {};
      const publishBlocked = rd.publishBlocked || rd.PublishBlocked;
      if (publishBlocked || e?.response?.status === 400) {
        const missing = rd.missingFields || rd.MissingFields || [];
        setWarningToastMessage(
          e?.response?.data?.message ||
            `Add ${missing.length ? missing.join(" and ") : "skills and match weights"} before publishing. Job remains a draft.`
        );
        setShowWarningToast(true);
        if (jobId && missing.some((f) => String(f).toLowerCase().includes("weight"))) {
          window.dispatchEvent(new CustomEvent("wlj-fix-job", { detail: { jobId, field: "weights" } }));
        }
        return;
      }
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e?.response?.data?.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e?.response?.data?.message);
        setShowErrorToast(true);
      }
    }
  };

  const [jobData, setJobData] = useState("");
  const JobDetails = async () => {
    try {
      // setLoading(true);
      await axios
        .get(`Job/GetJobDetails?DeviceType=Web&JobId=${jobId}&langKey=${language}`)
        .then((resData) => {
          console.log("hjsddsd", resData.data.responseData);
          setJobData(resData.data.responseData.viewJob);
        });
    } catch (error) {
      console.log(error);
      // setLoading(false);
    }
  };
  console.log("jobData", jobData);

  const cleanShortDescription = (htmlString) => {
    return htmlString
      ?.replace(/<h3>/gi, "<div>")
      ?.replace(/<\/h3>/gi, "</div>")
      ?.replace(/<strong>/gi, "")
      ?.replace(/<\/strong>/gi, "");
  };

    // Creatable designation (create new if not present, else pick from DDL)
    const [pageD, setPageD] = useState(0);
    const [typeddesignation, setTypeddesignation] = useState("");
    const [optionsD, setOptionsD] = useState([]);
    const [totalPagesdesignation, setTotalPagesdesignation] = useState(0);
    const [showInputInsteadOfDropdownD, setShowInputInsteadOfDropdownD] = useState(false);
    const [designation, setdesignation] = useState("");

    const logValueD = debounce((val) => {
      setTypeddesignation(val);
    }, 250);

    const addOptionsdesignation = () => {
      setIsLoading(true);
      axios
        .get(
          `Master/GetDesignationDDL?DeviceType=Web&search=${typeddesignation}&Fitid=${master.fitid || ""}&pageNumber=${pageD + 1}&pageSize=100&LangKey=${language}`
        )
        .then((response) => {
          const data = response?.data?.responseData?.data?.map((item) => ({
            label: item.name,
            value: item.dsgntnId,
          }));
          setPageD((prevPage) => prevPage + 1);
          setIsLoading(false);
          setOptionsD((prev) => [...prev, ...(data || [])]);
          setTotalPagesdesignation(response?.data?.paging?.totalPages || 0);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    };

    const handleOpendesignation = () => {
      setPageD(1);
      if (optionsD.length === 0) addOptionsdesignation();
    };

    const handleChangedesignation = (selectedOption) => {
      if (!selectedOption) {
        setdesignation("");
        setValue(null);
      } else {
        // if existing option (numeric id) keep id in `value`, else created string
        setdesignation(selectedOption.label);
        setValue(selectedOption);
        // if user picked an existing option, keep the dropdown; if they picked a created option, switch to input to allow edit
        if (typeof selectedOption.label === "string" && isNaN(selectedOption.label)) {
          setShowInputInsteadOfDropdownD(true);
        }
      }
    };

    const handleInputChangedesignation = (typed) => {
      logValueD(typed);
      if (!typed) setPageD(0);
    };

    const handleMenuScrollToBottomdesignation = () => {
      if (pageD < totalPagesdesignation) {
        addOptionsdesignation();
      }
    };

    useEffect(() => {
      if (typeddesignation) {
        addOptionsdesignation();
      }
    }, [typeddesignation]);

    console.log("companyList", companyList);
    
  return (
    <div>
      {openModal && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd jobCreate modal-lg wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content d-flex flex-column">
              <div className="setting-header d-flex justify-content-between align-items-center">
                <h6>{t("Newsfeed.Create Job")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {

                    if (activeStep >= 2) {
                      UpdateDraft().then(() => {
                        setToastMessage(t("Validation.DraftUpdated"));
                        setShowToast(true);
                        setTimeout(() => {
                          closeModal();
                        }, 200); // Adjust the delay if necessary
                      });
                    } else {
                      closeModal(); // If not on step 2, just close the modal normally
                    }
                  }
                  } />
              </div>
              <div className="bs-stepper">
                <div className="bs-stepper-content p-0">
                  <div
                    id="logins-part"
                    className={`content ${activeStep === 1 ? "active" : ""}`}
                    role="tabpanel"
                    aria-labelledby="logins-part-trigger"
                  >
                    <Row>
                    {!companyDetails?.compUid &&
                      !isCompanyLoading &&
                      companyData.length === 0 && (
                      <p className="text-danger mt-2 ms-4">{t("Validation.FirstCreateCompany")}</p>
                    )}
                      <Col md={12}>
                        <Form onSubmit={(e) => e.preventDefault()}>
                          <div className="row p-4 pt-0 settings CreateCompany  p-0">
                            <div className="col-md-6 mt-2">
                              <label htmlFor="about">
                                {t("Newsfeed.Company Name")}
                               {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>

                              <Select
                                value={companyData.find((option) => option.value === companyId) || null}
                                onChange={(selectedOption) => {
                                  setCompanyId(selectedOption ? selectedOption.value : null);
                                  if (selectedOption) {
                                    master.applyCompanyIndustry(selectedOption);
                                  } else {
                                    master.resetMaster();
                                  }
                                }}
                                options={companyData}
                                placeholder= {t("Newsfeed.Company Name")}
                                classNamePrefix="wlj-select"
                                styles={customStyles}
                                {...wljSelectPortalProps}
                                isClearable
                                onMenuOpen={getCompany}

                              />
                              {display && !companyId ? (
                                <span className="error_msg_lbl">
                                   {t("Newsfeed.Select Company Name")}
                                  {" "}
                                </span>
                              ) : null}
                            </div>

                            <div className="col-md-6 mt-2">
                              <label htmlFor="industry">
                                {t("User Profile.Industry")}
                                {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                value={master.industry}
                                onChange={master.onIndustryChange}
                                options={master.industryList}
                                placeholder={t("User Profile.Select industry")}
                                classNamePrefix="wlj-select"
                                styles={customStyles}
                                {...wljSelectPortalProps}
                                isClearable
                              />
                            </div>

                            <div className="col-md-12 mt-2">
                              <label htmlFor="about">
                                {t("Newsfeed.Designation")}
                                {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>

                              <CreatableSelect
                                options={master.designationOptions.length ? master.designationOptions : optionsD}
                                classNamePrefix="wlj-select"
                                styles={customStyles}
                                {...wljSelectPortalProps}
                                placeholder={t("Newsfeed.Select Designation")}
                                noOptionsMessage={() => t("modals.Search and Select Designation")}
                                onMenuOpen={master.onDesignationMenuOpen}
                                onChange={(selectedOption) => {
                                  master.setDesignation(selectedOption);
                                  handleChangedesignation(selectedOption);
                                }}
                                onMenuScrollToBottom={master.onDesignationMenuScroll}
                                onInputChange={master.onDesignationInputChange}
                                isClearable
                                isDisabled={!master.fitid}
                                isLoading={master.designationLoading}
                                isValidNewOption={(inputValue, _, selectOptions) =>
                                  !!inputValue && !selectOptions.some(option => option.label === inputValue)
                                }
                                onCreateOption={async (inputValue) => {
                                  const option = await master.createDesignation(inputValue);
                                  setdesignation(inputValue);
                                  setValue(option);
                                }}
                                value={master.designation || value}
                                className={display && !value ? "is-invalid" : ""}
                              />
                              {display && !value && !master.designation ? (
                                <span className="error_msg_lbl">
                                  {t("Newsfeed.Select Designation")}
                                  {" "}
                                </span>
                              ) : null}
                            </div>

                            <div className="col-md-12 mt-2">
                              <label htmlFor="skills">
                                {t("User Profile.Skills")}
                              </label>
                              <CreatableSelect
                                {...creatableSkillSelectDefaults}
                                value={master.skills}
                                options={master.skillOptions}
                                placeholder={t("User Profile.Search and Select Skill")}
                                onMenuOpen={master.onSkillMenuOpen}
                                onChange={(selected) => master.setSkills(selected || [])}
                                onMenuScrollToBottom={master.onSkillMenuScroll}
                                onInputChange={onCreatableInputChange(master.onSkillInputChange)}
                                onCreateOption={master.createSkill}
                                isDisabled={false}
                                isLoading={master.skillLoading}
                                classNamePrefix="wlj-select"
                                styles={customStyles}
                                {...wljSelectPortalProps}
                              />
                              <SkillSuggestChips
                                title={jobTitle}
                                fitid={master.fitid}
                                selected={master.skills}
                                onAdd={(option) => {
                                  const exists = (master.skills || []).some(
                                    (s) => String(s.value) === String(option.value) || s.label === option.label
                                  );
                                  if (!exists) master.setSkills([...(master.skills || []), option]);
                                }}
                              />
                            </div>

                            <div className="col-md-6 mt-2">
                              <label htmlFor="about">
                                {t("Newsfeed.Job Title")}
                                {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="JobTitleInputField"
                                value={jobTitle}
                                onChange={(e) => setjobTitle(e.target.value)}
                              />
                              {display && !jobTitle ? (
                                <span className="error_msg_lbl">
                                   {t("Newsfeed.Enter Job Title")}
                                  {" "}
                                </span>
                              ) : null}
                            </div>

                            <div className="col-md-6 mt-2">
                              <label htmlFor="about">
                                 {t("Newsfeed.City Name")}
                                {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                                <Select
                                  defaultValue={cityId}
                                  onChange={(selectedOption) =>
                                    setCityId(selectedOption ? selectedOption.value : null)
                                  }
                                  // show options only when user has typed a search term
                                  options={citySearch && citySearch.length > 0 ? cityData : []}
                                  noOptionsMessage={({ inputValue }) =>
                                    inputValue && inputValue.length > 0
                                      ? "No cities found"
                                      : t("modals.Search and Select City")
                                  }
                                  placeholder={t("Newsfeed.Select City")}
                                  onInputChange={(inputValue) => {
                                    setCitySearch(inputValue);
                                  }}
                                  // don't auto-load options on menu open to avoid showing all cities
                                  classNamePrefix="wlj-select"
                                styles={customStyles}
                                {...wljSelectPortalProps}
                                  isClearable 
                                />
                              {display && !cityId ? (
                                <span className="error_msg_lbl">
                                  {t("Newsfeed.Select City")}
                                 {" "}
                                </span>
                              ) : null}
                            </div>

                            <div className="col-md-6 mt-2">
                              <label htmlFor="about"> 
                                 {t("Newsfeed.Job Type")}<span className="text-danger ms-2">*</span>
                              </label>
                              <Select
                                defaultValue={jobTypeId}
                                onChange={(e) => {
                                  setJobTypeId(e ? e.value : null);
                                }}
                                options={jobTypeData}
                                placeholder= {t("Newsfeed.Select Job Type")}
                                classNamePrefix="wlj-select"
                                styles={customStyles}
                                {...wljSelectPortalProps}
                                isClearable
                                isSearchable={false}
                                onMenuOpen={getJobType}

                              />
                              {display && !jobTypeId ? (
                                <span className="error_msg_lbl">
                                  {t("Newsfeed.Select Job Type")}
                                  {" "}
                                </span>
                              ) : null}
                            </div>

                            <div className="col-md-6 mt-2">
                              <label htmlFor="about">
                                {t("Newsfeed.Work Level Type")}
                                {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Select
                                defaultValue={workTypeId}
                                onChange={(e) => {
                                  setWorkTypeId(e ? e.value : null);
                                }}
                                options={workTypeData}
                                placeholder= {t("Newsfeed.Select Work Level Type")}
                                classNamePrefix="wlj-select"
                                styles={customStyles}
                                {...wljSelectPortalProps}
                                isClearable
                                onMenuOpen={getWorkType}
                                isSearchable={false} 

                              />
                              {display && !workTypeId ? (
                                <span className="error_msg_lbl">
                                  {t("Newsfeed.Select Work Level Type")}
                                 {" "}
                                </span>
                              ) : null}
                            </div>

                            <div className="col-md-6 mt-2">
                              <label htmlFor="about">
                                 {t("Newsfeed.Work Location Type")}
                                {" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              {/* <input type='text' /> */}
                              <Select
                                defaultValue={workLocationId}
                                onChange={(e) => {
                                  setWorkLocationId(e ? e.value : null);
                                }}
                                options={workLocationData}
                                classNamePrefix="wlj-select"
                                styles={customStyles}
                                {...wljSelectPortalProps}
                                placeholder= {t("Newsfeed.Select Work Location Type")}
                                isClearable
                                onMenuOpen={getWorkLocationType}
                                 isSearchable={false}

                              />
                              {display && !workLocationId ? (
                                <span className="error_msg_lbl">
                                  {t("Newsfeed.Select Work Location Type")}
                                 {" "}
                                </span>
                              ) : null}
                            </div>
                          </div>
                          <div className="wlj-job-create-footer">
                            <button
                              type="button"
                              className="mainBtn1"
                              onClick={() => {
                                if (
                                  jobTitle === "" ||
                                  cityId === "" ||
                                  jobTypeId === "" ||
                                  companyId === "" ||
                                  workTypeId === "" ||
                                  workLocationId === ""
                                ) {
                                  setWarningToastMessage(
                                    "Please fill all fields"
                                  );
                                  setDisplay(true);
                                  setShowWarningToast(true);
                                } else {
                                  handleNext();
                                  SaveDraft();
                                }
                              }}
                              disabled={
                                cityId === null ||
                                jobTypeId === null ||
                                companyId === null ||
                                workTypeId === null ||
                                workLocationId === null ||
                                jobTitle === "" ||
                                value === null
                              }
                            >
                              {t("Newsfeed.Next")}
                              
                            </button>
                          </div>
                        </Form>
                      </Col>
                    </Row>
                  </div>
                  <div
                    id="information-part"
                    className={`content ${activeStep === 2 ? "active" : ""}`}
                    role="tabpanel"
                    aria-labelledby="information-part-trigger"
                  >
                    <Row>
                      <Col md={12}> 
                        <div className="row p-4 pt-0 settings CreateCompany  p-0">


                          <div className="col-md-12 mt-2">
                            <label htmlFor="about">{t("Newsfeed.Salary Type")}<span style={{ color: "red" }}>*</span></label>
                            <Select
                              defaultValue={salaryId}
                              onChange={(e) => {
                                setsalaryId(e.value);
                                // UpdateDraft();
                              }}
                              options={salaryData}
                              classNamePrefix="wlj-select"
                                styles={customStyles}
                                {...wljSelectPortalProps}
                              placeholder= {t("Newsfeed.Select Salary Type")}
                              onMenuOpen={getsalaryType}
                              isSearchable={false}
                             />
                            {/* {display && !salaryId ? (
                              <span className="error_msg_lbl">
                                Select Salary Type{" "}
                              </span>
                            ) : null} */}
                          </div>

                          <div className="col-md-6 mt-2">
                            <label htmlFor="about">{t("Newsfeed.Minimum Salary($)")}
                              {/* {minimumSalary && maximumSalary && parseFloat(minimumSalary) > parseFloat(maximumSalary) && (
                              <span className="text-danger ms-2">{t("Common.MinCannotExceedMax")}</span>
                            )} */}
                            </label>
                            <input
                              type="number"
                              value={minimumSalary}
                              onChange={(e) => {
                                setMinimumSalary(e.target.value);
                                // UpdateDraft();
                              }}
                            />
                            {/* {display && !minimumSalary ? (
                              <span className="error_msg_lbl">
                                Enter Minimum Salary{" "}
                              </span>
                            ) : null} */}
                          </div>

                          <div className="col-md-6 mt-2">
                            <label htmlFor="about">{t("Newsfeed.Maximum Salary($)")}
                              {minimumSalary && maximumSalary && parseFloat(minimumSalary) > parseFloat(maximumSalary) && (
                                <span className="text-danger ms-2">{t("Drafts.Max cannot be less than Min")}</span>
                              )}
                            </label>
                            <input
                              type="number"
                              value={maximumSalary}
                              onChange={(e) => setMaximumSalary(e.target.value)}
                            />
                            {/* {display && !maximumSalary ? (
                              <span className="error_msg_lbl">
                                Enter Maximum Salary{" "}
                              </span>
                            ) : null} */}
                          </div>
                          <div className="col-md-12 mt-2">
                            <label htmlFor="about">
                              {t("Newsfeed.Job Description")}
                              <span style={{ color: "red" }}>*</span>
                            </label>

                            <ReactQuill
                              theme="snow"
                              value={jobDescription}
                              onChange={setjobDescription}
                              id="about"
                              style={{ height: "130px", marginBottom: "16px" }}
                            />


                            {display && !jobDescription?.replace(/<(.|\n)*?>/g, '').trim() ? (
                              <span className="error_msg_lbl">Enter Job Description</span>
                            ) : null}
                          </div>
                        </div>
                          <div className="wlj-job-create-footer">
                            <div className="previousBtnCont d-flex align-items-center">
                              <button
                                type="button"
                                className="mainBtn1"
                                onClick={handlePrev}
                              >
                                <ArrowBackIosNewSharpIcon className="material-symbols-sharp" />
                                {t("Newsfeed.Previous")}
                              </button>
                            </div>
                            <button
                              type="button"
                              className="mainBtn1"
                              onClick={() => {
                                if ( 
                                  jobDescription === "" 
                                ) {
                                  setWarningToastMessage(
                                    "Please fill all fields"
                                  );
                                  setDisplay(true);
                                  setShowWarningToast(true);
                                } else {
                                  handleNext();
                                  UpdateDraft();
                                  JobDetails();
                                }
                              }}
                               disabled={ 
                                salaryId === null ||
                                minimumSalary === null ||
                                maximumSalary === null ||
                                jobDescription === "" ||
                                value === null
                              }
                            >
                               {t("Newsfeed.Next")}
                            </button>
                          </div>
                      </Col>
                    </Row>
                  </div>
                  <div
                    id="information-part"
                    className={`content ${activeStep === 3 ? "active" : ""}`}
                    role="tabpanel"
                    aria-labelledby="information-part-trigger"  >
                    <Row>
                      <Col md={12}>
                        <div className="jobdata-content-cont d-flex flex-column p-3 pb-0">
                          <p><span className="fw-bold">{t("Job Application.Job Description")} :</span>
                          <div
                              className="short-Des-jobCard fst-italic"
                              dangerouslySetInnerHTML={{
                                __html: cleanShortDescription(
                                  jobData?.fullDescription?.length > 50
                                    ? jobData?.fullDescription?.slice(0, 50) + "..."
                                    : jobData?.fullDescription
                                ),
                              }}
                              // style={{ fontSize: "12px", lineHeight: "1.5" }}
                            />
                            </p>
                          <p><span className="fw-bold ">{t("Newsfeed.Job Title")} :</span> {jobData.title}</p>
                          <p><span className="fw-bold ">{t("Newsfeed.Company Name")} :</span> {jobData.compName}</p>
                          <p><span className="fw-bold ">{t("SearchJob.Work Location")} :</span> ({jobData.workLocationTypeName})</p>
                          <p><span className="fw-bold ">{t("Newsfeed.Maximum Salary($)")} :</span> {jobData.salaryDisplay}</p>
                        </div>
                      </Col>

                      <Col md={12}>
                        <Form onSubmit={(e) => e.preventDefault()}>
                          <div className="wlj-job-create-footer">
                            <div className="previousBtnCont d-flex align-items-center">
                              <button
                                type="button"
                                className="previousBtn"
                                onClick={handlePrev}
                              >
                                <ArrowBackIosNewSharpIcon className="material-symbols-sharp" />
                                {t("Newsfeed.Previous")}
                              </button>
                            </div>
                            <button
                              type="submit"
                              className="mainBtn1 jobPosting"
                              onClick={(e) => {
                                e.preventDefault();
                                UpdateJob();
                              }}
                            >
                              {t("Newsfeed.Complete Job Posting")}
                            </button>
                          </div>
                        </Form>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </div>
  );
};

export default DraftJob;
